import { styled } from 'styled-components';

export const CallRatesTabsContainer = styled.div`
  width: 1024px;
  ${({ theme }) => theme.breakpoints.md.query} {
    width: 100%;
  }
`;
